<template>
  <div>
    <div class="border-bottom">
      <b-col
        md="12"
        :class="$style.reportInfoHead"
        class="mt-4 text-white py-3 px-3 font-weight-bold"
        >Summary of Findings</b-col
      >
    </div>
    <div class="border mb-4" :class="$style.reportCard">
      <div></div>
      <div v-if="SHOW_BORROWER_INFO">
      <div v-for="(dataItem, dataInex) in BORROWER_DATA" :key="dataInex" class="m-2 bg-white border roundedReportCard">
        <p class="font-weight-bold m-2 subHeading"
          >Borrower Detail Report
          {{ dataItem.borrowerName ? '- ' : null }}{{ formatData(dataItem.borrowerName) | capitalize }}</p
        >
        <div v-if="SUMMARY_ERRORS.borrower[dataInex].borrowerRisk === null">
        <div v-if="displayBorrowerRisks(dataItem.followUps, dataItem.riskIndicators)">
        <div v-if="dataItem.riskIndicators.length" class="mb-2">
          <b-row
            v-for="(item, index) in dataItem.riskIndicators"
            :key="index"
            class="mx-2 baseContentFont"
            :class="{ [$style.stripedRow]: index % 2 === 1 }"
          >
            <b-col
              md="2"
              class="border border-right-0"
              :class="{
                'border-bottom-0': index < dataItem.riskIndicators.length - 1,
                [$style.radiusTopLeft]: index === 0,
                [$style.radiusBottomLeft]: index === dataItem.riskIndicators.length - 1,
              }"
            >{{
              formatData(item.riskIndicator)
            }}</b-col>
            <b-col
              md="1"
              class="border border-right-0 px-2"
              :class="{
                    'border-bottom-0': index < dataItem.riskIndicators.length - 1,
                    [$style.riskLow]: item.riskLevel === riskStatus.low,
                    [$style.riskLevel]: item.riskLevel === riskStatus.high,
                    [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                  }"
              >{{ formatData(item.riskLevel) }}</b-col
            >
            <b-col
              md="7"
              class="border border-right-0"
              :class="{ 'border-bottom-0': index < dataItem.riskIndicators.length - 1 }"
            >
              <div v-for="(items, index1) in item.riskcomments" :key="items">
                <div v-if="index1 === 0"
                  >{{ formatData(items) }}
                </div>
                <div v-else>
                  <div v-if="index1 === 1">
                      Note Log:
                    </div>
                  <div>{{ formatData(items) }}</div></div
                >
              </div>
            </b-col>


            <b-col
              md="1"
              class="border border-right-0 px-2"
              :class="{
              'border-bottom-0': index < dataItem.riskIndicators.length - 1,
              [$style.riskLow]: item.riskDescription === riskStatus.cleared,
              [$style.riskLevel]: item.riskDescription === riskStatus.caution,
            }"
            >{{
  formatData(item.riskDescription)
}}</b-col>

            <b-col
              md="1"
              class="border"
              :class="{
                'border-bottom-0': index < dataItem.riskIndicators.length - 1,
                [$style.radiusTopRight]: index === 0,
                [$style.radiusBottomRight]: index === dataItem.riskIndicators.length - 1,
              }"
            >
              <b-link v-if="!readOnly" class="fraudReportLink" @click="addupdate(item.id, item.riskDescription)"><u>Update</u></b-link>
              <span v-else v-b-tooltip.hover.left class="text-muted" :title="featureDisabled">Update</span>
            </b-col>
          </b-row>
        </div>
        <NoRecordFound
          v-else
          message-required
          class="m-2"
        ></NoRecordFound>
        </div>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.borrower[dataInex].borrowerRisk"/>
        <div v-if="dataItem.followUps.length && SUMMARY_ERRORS.borrower[dataInex].borrowerRisk === null" class="pb-2">
        <div v-for="(item, index) in dataItem.followUps" :key="index">
          <b-row
            class="mx-2 baseContentFont"
            :class="{ [$style.stripedRow]: index % 2 === 1 }"
          >
            <b-col
              md="3"
              class="border border-right-0"
              :class="{
                'border-bottom-0': index < dataItem.followUps.length - 1,
                [$style.radiusTopLeft]: index === 0,
                [$style.radiusBottomLeft]: index === dataItem.followUps.length - 1,
              }"
            >{{
              formatData(item.followUp)
            }}</b-col>

            <b-col
              md="9"
              class="border"
              :class="{
                'border-bottom-0': index < dataItem.followUps.length - 1,
                [$style.radiusTopRight]: index === 0,
                [$style.radiusBottomRight]: index === dataItem.followUps.length - 1,
              }"
            >{{
              formatData(item.followUpDetails)
            }}</b-col>
          </b-row>
        </div>
        </div>
        <!-- <div class="border mb-4"></div> -->
      </div>
      </div>
      <div v-if="SHOW_PROPERTY_INFO && !isBatchOrder">
        <div></div>
        <div class="border m-2 bg-white roundedReportCard">
          <p class="font-weight-bold m-2 subHeading"
            >Property Detail Report
          {{ PROPERTY_INFO_ADDRESS ? '- ' : null }}{{ formatData(PROPERTY_INFO_ADDRESS) | capitalize }}</p>
          <div v-if="SUMMARY_ERRORS.property === null">
          <div v-if="PROPERTY_INFO.length" class="pb-2">
            <b-row
              v-for="(item, index) in PROPERTY_INFO"
              :key="index"
              class="mx-2 baseContentFont"
              :class="{ [$style.stripedRow]: index % 2 === 1 }"
            >
              <b-col
                md="2"
                class="border border-right-0"
                :class="{
                  'border-bottom-0': index < PROPERTY_INFO.length - 1,
                  [$style.radiusTopLeft]: index === 0,
                  [$style.radiusBottomLeft]: index === PROPERTY_INFO.length - 1,
                }"
              >{{
                formatData(item.riskIndicator)
              }}</b-col>
              <b-col
                md="1"
                class="border border-right-0 px-2"
                :class="{
                      'border-bottom-0': index < PROPERTY_INFO.length - 1,
                      [$style.riskLow]: item.riskLevel === riskStatus.low,
                      [$style.riskLevel]: item.riskLevel === riskStatus.high,
                      [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                    }"
                >{{ formatData(item.riskLevel) }}</b-col
              >
              <b-col
                md="7"
                class="border border-right-0"
                :class="{ 'border-bottom-0': index < PROPERTY_INFO.length - 1 }"
              >
                <div v-for="(items, index1) in item.riskcomments" :key="items">
                  <div v-if="index1 === 0" class="textSpacing"
                    >{{ formatData(items) }}
                  </div>
                  <div v-else>
                    <div v-if="index1 === 1">
                      Note Log:
                    </div>
                    <div>{{ formatData(items) }}</div>
                  </div>
                </div>
              </b-col>


              <b-col
                md="1"
                class="border border-right-0 px-2"
                :class="{
                'border-bottom-0': index < PROPERTY_INFO.length - 1,
                [$style.riskLow]: item.riskDescription === riskStatus.cleared,
                [$style.riskLevel]: item.riskDescription === riskStatus.caution,
              }"
                >{{ formatData(item.riskDescription) }}</b-col>
              <b-col
                md="1"
                class="border"
                :class="{
                  'border-bottom-0': index < PROPERTY_INFO.length - 1,
                  [$style.radiusTopRight]: index === 0,
                  [$style.radiusBottomRight]: index === PROPERTY_INFO.length - 1,
                }"
              >
                <b-link v-if="!readOnly" class="fraudReportLink" @click="addupdate(item.id, item.riskDescription)"><u> Update</u></b-link>
                <span v-else v-b-tooltip.hover.left class="text-muted" :title="featureDisabled">Update</span>
              </b-col>
            </b-row>
          </div>
          <NoRecordFound
            v-else
            message-required
            class="m-2"
          ></NoRecordFound>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.property"/>
        </div>
      </div>
      <div v-if="driverInformation.participantResponses && !isBatchOrder">
        <div></div>
        <div class="m-2 bg-white border roundedReportCard">
          <p class="font-weight-bold m-2 subHeading"
            >Participant Detail Report</p
          >
          <div v-if="SUMMARY_ERRORS.participant === null">
          <div
            v-if="driverInformation.riskIndicators !== null &&
              driverInformation.riskIndicators.length > 0
              "
            class="pb-2"
          >
            <b-row
              v-for="(item, index) in driverInformation.riskIndicators"
              :key="index"
              class="mx-2 baseContentFont"
              :class="{ [$style.stripedRow]: index % 2 === 1 }"
            >
              <b-col
                md="2"
                class="border border-right-0"
                :class="{
                  'border-bottom-0': index < driverInformation.riskIndicators.length - 1,
                  [$style.radiusTopLeft]: index === 0,
                  [$style.radiusBottomLeft]: index === driverInformation.riskIndicators.length - 1,
                }"
              >{{
                formatData(item.riskIndicator)
              }}</b-col>
              <b-col
                md="1"
                class="border border-right-0 px-2"
                :class="{
                      'border-bottom-0': index < driverInformation.riskIndicators.length - 1,
                      [$style.riskLow]: item.riskLevel === riskStatus.low,
                      [$style.riskLevel]: item.riskLevel === riskStatus.high,
                      [$style.riskMedium]: item.riskLevel === riskStatus.medium,
                    }"
                >{{ formatData(item.riskLevel) }}</b-col
              >
              <b-col
                md="7"
                class="border border-right-0"
                :class="{ 'border-bottom-0': index < driverInformation.riskIndicators.length - 1 }"
              >
                <div v-for="(items, index1) in item.riskcomments" :key="items">
                  <div v-if="index1 === 0" class="textSpacing"
                    >{{ formatData(items) }}
                  </div>
                  <div v-else>
                    <div v-if="index1 === 1">
                      Note Log:
                    </div>
                    <div >{{ formatData(items) }}</div>
                  </div>
                </div>
              </b-col>


              <b-col
                md="1"
                class="border border-right-0 px-2"
                :class="{
                'border-bottom-0': index < driverInformation.riskIndicators.length - 1,
                [$style.riskLow]: item.riskDescription === riskStatus.cleared,
                [$style.riskLevel]: item.riskDescription === riskStatus.caution,
              }"
              >{{
  formatData(item.riskDescription)
}}</b-col>

              <b-col
                md="1"
                class="border"
                :class="{
                  'border-bottom-0': index < driverInformation.riskIndicators.length - 1,
                  [$style.radiusTopRight]: index === 0,
                  [$style.radiusBottomRight]: index === driverInformation.riskIndicators.length - 1,
                }"
              >
                <b-link v-if="!readOnly" class="fraudReportLink" @click="addupdate(item.id, item.riskDescription)"><u> Update</u></b-link             >
                <span v-else v-b-tooltip.hover.left class="text-muted" :title="featureDisabled">Update</span>
              </b-col>
            </b-row>
          </div>
          <NoRecordFound
            v-else
            message-required
            class="m-2"
          ></NoRecordFound>
        </div>
        <CustomMessage v-else class="m-2" :custom-msg="SUMMARY_ERRORS.participant"/>
        </div>
        <div class="border-top"></div>
      </div>
      <div class="d-flex justify-content-between py-2">
        <div class="font-weight-bold ml-4">Remarks</div>
        <div class="mr-4 baseContentFont">
          <b-link v-if="!readOnly" class="fraudReportLink" @click="addcomments"><u>Add Comments</u></b-link>
          <span v-else v-b-tooltip.hover.left class="text-muted" :title="featureDisabled">Add Comments</span>
        </div>
      </div>
      <div
        v-for="(item, index) in propertyComments"
        :key="index"
        class="ml-4 mb-1 baseContentFont"
        >{{ item }}</div
      >
    </div>
  </div>
</template>

<script>
import constant from '@constants/constant.json'
import NoRecordFound from '@src/components/_norecord-found.vue'
import { uppercase, capitalize } from "@/src/utils/filters"
import CustomMessage from '@/src/components/_custom-message.vue'
export default {
  components: { NoRecordFound, CustomMessage },
  filters: {
    uppercase,
    capitalize,
  },
  props: {
    associatedBusiness: {
      type: Array,
      default: () => [],
    },
    driverInformation: {
      type: Object,
      default: () => {},
    },
    propertyComments: {
      type: Array,
      default: () => [],
    },
    propertyInformation: {
      type: Object,
      default: () => {},
    },
    showPropertyDetails: {
      type: Boolean,
      default: false,
    },
    showBorrowerDetails: {
      type: Boolean,
      default: false,
    },
    isBatchOrder: {
      type: Boolean,
      default: false,
    },
    summaryErrors: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      propertystatus: '',
      validateRecordTypes: [1, 2, 3],
      riskStatus: constant.RiskIndicatorItems,
      featureDisabled: constant.featureDisabled,
    }
  },
  computed: {
    BORROWER_DATA() {
      return this.associatedBusiness
    },
    SHOW_BORROWER_INFO() {
      return this.showBorrowerDetails
    },
    SHOW_PROPERTY_INFO() {
      return this.showPropertyDetails
    },
    PROPERTY_INFO_ADDRESS() {
      return this.propertyInformation !== null
        ? this.propertyInformation.propertyAddress
        : null
    },
    PROPERTY_INFO() {
      return this.propertyInformation !== null
        ? this.propertyInformation.riskResponseModel
          ? this.propertyInformation.riskResponseModel || []
          : []
        : []
    },
    SUMMARY_ERRORS() {
      return this.summaryErrors
    },
  },
  methods: {
    addcomments() {
      this.$emit('addcomments')
    },
    addupdate(id, name) {
      this.$emit('addupdated', id, name)
    },
    formatData(data) {
      return data || null
    },
    displayBorrowerRisks(followUps, risks) {
      return !(followUps.length && !risks.length)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.reportInfoHead {
  margin: auto;
  background: linear-gradient(90deg, #5C068C 0%, #9840C7 100%) !important;
  border-radius: 4px 4px 0 0;
}

.reportCard {
  color: #171A23;
  border-radius: 0 0 4px 4px;
}

.stripedRow {
  background-color: #F3F5F6;
}

.radiusTopLeft {
  border-top-left-radius: 4px;
}

.radiusTopRight {
  border-top-right-radius: 4px;
}

.radiusBottomLeft {
  border-bottom-left-radius: 4px;
}

.radiusBottomRight {
  border-bottom-right-radius: 4px;
}

.riskLevel {
  font-weight: 700;
  color: $color-accent-red;
  background-color: $color-accent-error-30;
}

.riskLow {
  font-weight: 700;
  color: $color-accent-green;
  background-color: $color-accent-success-20;
}

.riskMedium {
  font-weight: 700;
  color: $color-accent-orange;
  background-color: $color-accent-warning-20;
}
// .reportInfoHead {
//   letter-spacing: normal;
//   letter-spacing: 0.4em;
//   letter-spacing: 4px;
//   letter-spacing: 0.4px;
// }
</style>

<style lang="scss" scoped>
@import '@design';
a.fraudReportLink {
  color: $color-dark-purple;
}
.subHeading,
.textSpacing {
  /* letter-spacing: normal;
  letter-spacing: 0.4em;
  letter-spacing: 4px;
  letter-spacing: 0.4px; */
}

.roundedReportCard {
  overflow: hidden;
  border-radius: 4px;
}
</style>
